import React from 'react';
import { Spin } from 'antd';

const PageSpinner = () => (
	<div className={'fullscreen__spinner__wrapper'}>
		<Spin size={'large'} />
	</div>
);

export default PageSpinner;
